import React, { useState, useEffect, useRef } from "react";
import poster from "../../assets/images/sankalbanner.png";   
import videoFile from "../../assets/images/sankal-videos.mp4";  

function VideoSection() {
  const [play, setPlay] = useState(false);
  const videoWrapperRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Auto-play when section comes into view
            setPlay(true);
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of the section is visible
      }
    );

    if (videoWrapperRef.current) {
      observer.observe(videoWrapperRef.current);
    }

    return () => {
      if (videoWrapperRef.current) {
        observer.unobserve(videoWrapperRef.current);
      }
    };
  }, []);

  return (
    <div className="video-wrapper" ref={videoWrapperRef}>
      <div className="video-box">
        {!play ? (
          <>
            <img src={poster} alt="video thumbnail" />

            <div className="play-btn" onClick={() => setPlay(true)}>
              ▶
            </div>
          </>
        ) : (
          <video controls autoPlay muted playsInline>
            <source src={videoFile} type="video/mp4" />
          </video>
        )}
      </div>
    </div>
  );
}

export default VideoSection;
